<span class="badge badge-pill badge-soft-danger font-size-11">{{ 'UTILS.COMMON.MISSING_DATA' | translate }} </span>
